var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.base.card, _vm.space[_vm.spaceClass({ size: _vm.padding })]]},[_vm._t("default",[_vm._v("Add content here")]),_c('div',{class:_vm.base.footer},[_vm._t("footer")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }